import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Home from "../pages/home/home";
import Admin from "../pages/admin/admin";
import Profile from "../pages/profile/profile";
import Campaigns from "../pages/campaign/campaigns";
import Campaign from "../pages/campaign/campaign";
import Conversation from "../pages/conversation/conversation";
import Login from "../pages/login/login";
// import Organisation from "../pages/organisation/organisation";
import EditCompanyComponent from "../pages/organisation/organisation-setup";
import Playlists from "../pages/playlists/playlists";
import Privacy from "../pages/terms-and-privacy/privacy";
import Settings from "../pages/settings";
import Terms from "../pages/terms-and-privacy/terms";
import AdminUsers from "../pages/admin/admin-users";
import Trackers from "../pages/tracker/trackers";
import TrackerAdmin from "../pages/tracker/tracker-admin";
import Alerts from "../pages/alerts/alerts";
import Tracker from "../pages/tracker/tracker";
import SupportPage from "../pages/support";

const AppRoutes = ({ isUser }) => {

    const routes = useRoutes([
        {
            path: "/",
            element: (<>{isUser ? <Home /> : <Login />}</>),
        },
        {
            path: "/companies",
            element: <Admin />
        },
        {
            path: "/users",
            element: <AdminUsers />
        },
        {
            path: "/campaigns",
            element: <Campaigns />
        },
        {
            path: "/campaign",
            element: <Campaign />
        },
        {
            path: "/conversation",
            element: <Conversation />
        },
        {
            path: "/profile",
            element: <Profile />
        },
        // {
        //     path: "/organisation",
        //     element: <Organisation />
        // },
        {
            path: "/edit-company",
            element: <EditCompanyComponent />
        },
        {
            path: "/playlists",
            element: <Playlists />
        },
        {
            path: "/settings",
            element: <Settings />
        },
        {
            path: "/insight-admin",
            element: <TrackerAdmin />
        },
        {
            path: "/insights",
            element: <Trackers />
        },
        {
            path: "/insight-phrases",
            element: <Tracker />
        },
        {
            path: "/alerts",
            element: <Alerts />
        },
        {
            path: "/login",
            element: <Login />
        },
        {
            path: "/privacy",
            element: <Privacy />
        },
        {
            path: "/support",
            element: <SupportPage />
        },
        {
            path: "/terms",
            element: <Terms />
        },
        {
            path: "*",
            element: <Navigate to={"/"}/>
        }
    ]);

    return <>{routes}</>;
};

export default AppRoutes;
